export const identityCollections = [
  { id: "paddock", name: "Paddock Series", status: "active", description: "Motorsport-inspired build identity." },
  { id: "carbon", name: "Carbon Series", status: "comingSoon" },
  { id: "stealth", name: "Stealth Series", status: "comingSoon" },
  { id: "blueprint", name: "Blueprint Series", status: "comingSoon" },
  { id: "heritage", name: "Heritage Series", status: "comingSoon" },
  { id: "classic", name: "Classic Series", status: "comingSoon" }
];

export const getIdentityCollection = (id) => (
  identityCollections.find((collection) => collection.id === id && collection.status === "active")
  || identityCollections[0]
);
